import React from 'react';
import { Table } from '../common';
import { Button, TextLink } from '../common';
import serviceNow from '../../services/serviceNow.config';
import PortOpeningRequest from '../../models/entities/PortOpeningRequest';
import { WorkflowState } from '../../models/enums/WorkflowState';
import { useNavigate } from 'react-router-dom';
import ProgressBarSmall from './components/ProgressBarSmall';
import moment from 'moment';
import { Badge } from '@emorg-prd/standard-react';

interface PortOpeningRequestsHomeTableRowProps {
	request: PortOpeningRequest;
	subOwnerDisplayName?: string;
}

const PortOpeningRequestsHomeTableRow = ({ request, subOwnerDisplayName }: PortOpeningRequestsHomeTableRowProps) => {
	const navigate = useNavigate();
	const getTicketURL = (ticket: string) => {
		return ticket.toUpperCase().includes('CRQ')
			? `https://itconsole.na.xom.com/#/${ticket}`
			: `https://${serviceNow.serviceNowEnv}.service-now.com/nav_to.do?uri=change_request.do?sysparm_query=number=${ticket}&sysparm_limit=1`;
	};

	const linkToTicket = () => {
		const implementationTicket = request.implementationTicket();
		return implementationTicket !== '' ? (
			<TextLink external href={getTicketURL(implementationTicket)} target="_blank">
				{implementationTicket}&nbsp;
			</TextLink>
		) : (
			'-'
		);
	};

	const handleViewDetails = () => {
		navigate(`/subscriptions/${request.subscriptionRequestId}/portOpeningRequests/${request.id}`);
	};

	return (
		<Table.Row onClick={handleViewDetails}>
			<Table.Cell key={`${request.id}-id`}>{request.id}</Table.Cell>
			<Table.Cell key={`${request.id}-direction`}>{request.direction.displayName}</Table.Cell>
			<Table.Cell key={`${request.id}-createdBy`}>{request.workflowInstance.createdBy.displayName}</Table.Cell>
			<Table.Cell key={`${request.id}-contact`}>{request.contactUser?.displayName}</Table.Cell>
			<Table.Cell key={`${request.id}-owner`}>
				{request.workflowInstance.currentWorkflowInstanceState.workflowState ===
				WorkflowState.PendingSubscriptionOwnerApproval
					? subOwnerDisplayName
					: request.approvingUser?.displayName}
			</Table.Cell>
			<Table.Cell key={`${request.id}-date`}>
				{moment(new Date(request.workflowInstance.createdDate)).format('YYYY-MM-DD')}
			</Table.Cell>
			<Table.Cell key={`${request.id}-progress`}>
				<ProgressBarSmall
					workflowState={request.workflowInstance.currentWorkflowInstanceState.workflowState}
					porScope={request.direction.name}
				/>
			</Table.Cell>
			<Table.Cell key={`${request.id}-link`}>
				{request.implementationTicket() !== '' ? (
					<TextLink
						className="em-u-text-align-center"
						external
						href={getTicketURL(request.implementationTicket())}
						target="_blank"
					>
						{request.implementationTicket()}&nbsp;
					</TextLink>
				) : request.workflowInstance.currentWorkflowInstanceState.workflowState ===
					WorkflowState.Completed &&
					request.direction?.name === 'SubscriptionToInternet'
						? (
					<Badge
						text={'KEEP'}
						type={'em-c-badge--positive'}
					/>
				) : (
					'-'
				)}
			</Table.Cell>
		</Table.Row>
	);
};

export default PortOpeningRequestsHomeTableRow;
